// frontend-uie-smart/src/helper/supportHelper.ts
import { getFileAttachementByName } from "../api/fileAttachement";

type OpenSupportParams = {
  entityType: string;
  fileName: string;
  context?: any;
};

export const openSupportInNewTab = async ({
  entityType,
  fileName,
  context,
}: OpenSupportParams) => {
  const response = await getFileAttachementByName(
    entityType,
    fileName,
    context,
  );

  if (!response?.temporaryUrl) {
    throw new Error("URL temporaire introuvable.");
  }

  window.open(response.temporaryUrl, "_blank", "noopener,noreferrer");
};
